import type { ReactNode } from "react";

interface InfiniteMarqueeProps {
  children: ReactNode;
  speed?: number;
  reverse?: boolean;
  pauseOnHover?: boolean;
  className?: string;
}

export default function InfiniteMarquee({
  children,
  speed = 30,
  reverse = false,
  pauseOnHover = true,
  className,
}: InfiniteMarqueeProps) {
  const animName = reverse ? "marqueeRight" : "marqueeLeft";

  return (
    <div
      className={className}
      style={{
        overflow: "hidden",
        position: "relative",
        maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        WebkitMaskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "max-content",
          animation: `${animName} ${speed}s linear infinite`,
          ...(pauseOnHover ? {} : {}),
        }}
        onMouseEnter={(e) => {
          if (pauseOnHover) (e.currentTarget.style.animationPlayState = "paused");
        }}
        onMouseLeave={(e) => {
          if (pauseOnHover) (e.currentTarget.style.animationPlayState = "running");
        }}
      >
        {/* Duplicate for seamless loop */}
        <div style={{ display: "flex", alignItems: "center", gap: 48, paddingRight: 48 }}>{children}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 48, paddingRight: 48 }} aria-hidden>{children}</div>
      </div>
    </div>
  );
}
